// extracted by mini-css-extract-plugin
export default {"reminderItem":"style_reminderItem__h7V8x","closeIcon":"style_closeIcon__ceANx"};